import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Table, Button, Badge, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import { API_WEB_URLS } from "constants/constAPI";
import { Fn_GetReport } from "store/Functions";
import { Download, RefreshCw, Filter, TrendingUp, TrendingDown, Layers } from "react-feather";
import * as XLSX from "xlsx";

function SaudaPositionReport() {
  const dispatch = useDispatch();
  const globalDates = useSelector(state => state.GlobalDates);

  const [fromDate, setFromDate] = useState(globalDates.fromDate ? new Date(globalDates.fromDate) : new Date());
  const [toDate, setToDate] = useState(globalDates.toDate ? new Date(globalDates.toDate) : new Date());
  const [loading, setLoading] = useState(false);
  const [positionData, setPositionData] = useState([]);
  const [state, setState] = useState({ FillArray: [] });

  const API_URL = `${API_WEB_URLS.BASE || "/api/V1/"}SaudaPosition/0/token`;

  const loadData = async () => {
    setLoading(true);
    try {
      const vformData = new FormData();
      vformData.append("FromDate", fromDate.toISOString().split("T")[0]);
      vformData.append("ToDate", toDate.toISOString().split("T")[0]);

      const res = await Fn_GetReport(dispatch, setState, "FillArray", API_URL, { arguList: { id: 0, formData: vformData } }, true);
      if (res && Array.isArray(res)) {
        setPositionData(res);
      } else if (state.FillArray && state.FillArray.length > 0) {
        setPositionData(state.FillArray);
      }
    } catch (e) {
      console.error("Error loading Sauda Position:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const totalBuy = positionData.reduce((acc, row) => acc + (parseFloat(row.TotalBuyQty) || 0), 0);
  const totalSell = positionData.reduce((acc, row) => acc + (parseFloat(row.TotalSellQty) || 0), 0);
  const netPosition = totalBuy - totalSell;

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(positionData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SaudaPosition");
    XLSX.writeFile(wb, `Sauda_Position_${new Date().toISOString().split("T")[0]}.xlsx`);
  };

  return (
    <div className="page-content" style={{ padding: "15px" }}>
      <Container fluid>
        {/* Header Title */}
        <Row className="mb-2 align-items-center">
          <Col xs={12} md={6}>
            <h5 className="mb-0 fw-bold text-dark d-flex align-items-center">
              <Layers className="me-2 text-primary" size={22} />
              Item-wise Sauda Position & Stock Exposure (सौदा / स्टॉक स्थिति)
            </h5>
            <small className="text-muted">Real-time Net Open Position (Long / Short Analysis)</small>
          </Col>
          <Col xs={12} md={6} className="text-md-end mt-2 mt-md-0 d-flex justify-content-md-end gap-2 align-items-center">
            <DatePicker
              selected={fromDate}
              onChange={date => setFromDate(date)}
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm text-center"
              style={{ width: "110px" }}
            />
            <span className="text-muted">to</span>
            <DatePicker
              selected={toDate}
              onChange={date => setToDate(date)}
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm text-center"
              style={{ width: "110px" }}
            />
            <Button size="sm" variant="primary" onClick={loadData} disabled={loading}>
              <RefreshCw size={14} className={`me-1 ${loading ? "spin" : ""}`} /> Filter
            </Button>
            <Button size="sm" variant="success" onClick={exportToExcel} disabled={positionData.length === 0}>
              <Download size={14} className="me-1" /> Excel
            </Button>
          </Col>
        </Row>

        {/* Top Summary KPI Cards */}
        <Row className="g-2 mb-3">
          <Col xs={12} sm={4}>
            <Card className="border-0 shadow-sm rounded-3" style={{ borderLeft: "4px solid #198754" }}>
              <Card.Body className="p-2 d-flex align-items-center justify-content-between">
                <div>
                  <small className="text-muted text-uppercase fw-bold">Total Buy (कुल खरीद)</small>
                  <h4 className="mb-0 fw-bold text-success">{totalBuy.toFixed(2)} Qtl</h4>
                </div>
                <TrendingUp size={28} className="text-success opacity-75" />
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={4}>
            <Card className="border-0 shadow-sm rounded-3" style={{ borderLeft: "4px solid #0d6efd" }}>
              <Card.Body className="p-2 d-flex align-items-center justify-content-between">
                <div>
                  <small className="text-muted text-uppercase fw-bold">Total Sell (कुल बिक्री)</small>
                  <h4 className="mb-0 fw-bold text-primary">{totalSell.toFixed(2)} Qtl</h4>
                </div>
                <TrendingDown size={28} className="text-primary opacity-75" />
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={4}>
            <Card className="border-0 shadow-sm rounded-3" style={{ borderLeft: `4px solid ${netPosition >= 0 ? '#198754' : '#dc3545'}` }}>
              <Card.Body className="p-2 d-flex align-items-center justify-content-between">
                <div>
                  <small className="text-muted text-uppercase fw-bold">Net Position (नेट स्थिति)</small>
                  <h4 className={`mb-0 fw-bold ${netPosition >= 0 ? 'text-success' : 'text-danger'}`}>
                    {netPosition >= 0 ? `+${netPosition.toFixed(2)}` : netPosition.toFixed(2)} Qtl
                  </h4>
                </div>
                <Badge bg={netPosition >= 0 ? "success" : "danger"} className="p-2 fs-6">
                  {netPosition >= 0 ? "LONG (खरीद अधिक)" : "SHORT (बिक्री अधिक)"}
                </Badge>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Position Data Table */}
        <Card className="shadow-sm border-0">
          <Card.Body className="p-0">
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2 text-muted">Calculating Item-wise Open Positions...</p>
              </div>
            ) : (
              <Table responsive hover striped bordered className="mb-0 text-center align-middle" style={{ fontSize: "0.88rem" }}>
                <thead className="table-dark">
                  <tr>
                    <th>Item / Commodity</th>
                    <th className="table-success text-dark">Total Buy Qty</th>
                    <th className="table-success text-dark">Avg Buy Rate (₹)</th>
                    <th className="table-primary text-dark">Total Sell Qty</th>
                    <th className="table-primary text-dark">Avg Sell Rate (₹)</th>
                    <th>Net Position Qty</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {positionData.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="py-4 text-muted">
                        No contracts found for the selected period.
                      </td>
                    </tr>
                  ) : (
                    positionData.map((row, idx) => {
                      const netQty = (parseFloat(row.TotalBuyQty) || 0) - (parseFloat(row.TotalSellQty) || 0);
                      const isLong = netQty >= 0;
                      return (
                        <tr key={idx}>
                          <td className="fw-bold text-start ps-3">{row.ItemName}</td>
                          <td className="text-success fw-bold">{(parseFloat(row.TotalBuyQty) || 0).toFixed(2)}</td>
                          <td>₹ {(parseFloat(row.AvgBuyRate) || 0).toFixed(2)}</td>
                          <td className="text-primary fw-bold">{(parseFloat(row.TotalSellQty) || 0).toFixed(2)}</td>
                          <td>₹ {(parseFloat(row.AvgSellRate) || 0).toFixed(2)}</td>
                          <td className={`fw-bold ${isLong ? "text-success" : "text-danger"}`}>
                            {isLong ? `+${netQty.toFixed(2)}` : netQty.toFixed(2)}
                          </td>
                          <td>
                            <Badge bg={isLong ? "success" : "danger"}>
                              {isLong ? "LONG (खरीद अधिक)" : "SHORT (बिक्री अधिक)"}
                            </Badge>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default SaudaPositionReport;
